import type { MutableRefObject } from 'react';
import { Button } from '@fff-web/fff-ui-shared';
import { AnnualMemberContainer } from './components/AnnualMemberContainer/AnnualMemberContainer';
import { CurrentPlanCard } from './components/CurrentPlanCard/CurrentPlanCard';
import HeroBanner from './components/HeroBanner/HeroBanner';
import UpgradeDisclaimer from './components/UpgradeDisclaimer/UpgradeDisclaimer';
import { PRO_RATED_UPGRADE_MESSAGES } from './ProRatedUpgradeUtils';
import * as styles from './ProRatedUpgrade.module.scss';

interface ProRatedUpgradeProps {
  annualPrice: number;
  seasonalPrice: number;
  submitUpgrade: () => void;
  scrollToRef?: MutableRefObject<HTMLDivElement>;
  loading: boolean;
}

const ProRatedUpgrade = ({
  annualPrice,
  seasonalPrice,
  submitUpgrade,
  scrollToRef,
  loading,
}: ProRatedUpgradeProps) => {
  return (
    <main ref={scrollToRef} className={styles.wrapper}>
      <HeroBanner />
      <div className={styles.contentWrapper}>
        <AnnualMemberContainer annualPrice={annualPrice} />
        <CurrentPlanCard seasonalPrice={seasonalPrice} />
        <UpgradeDisclaimer />
      </div>
      <section className={styles.buttonsContainer}>
        <Button
          data-testid={PRO_RATED_UPGRADE_MESSAGES.proRatedUpgradeId}
          disabled={loading}
          onClick={submitUpgrade}
        >
          {PRO_RATED_UPGRADE_MESSAGES.ctaName}
        </Button>
      </section>
    </main>
  );
};

export { ProRatedUpgrade };
export type { ProRatedUpgradeProps };
